import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { getRentalPortalApplicantTimeline } from '../../../../api'
import { EMPTY_LIST } from '../../../../constants/common'
import { useInfiniteItemsListLoader } from '../../../../hooks'
import { getItemsFromIdwellApiResponse } from '../../../../utils/api'
import { getQaSelector } from '../../../../utils/common'
import Button from '../../../Button'
import { EntityProfileTabUpdates } from '../../../Entity'
import { PageEmptyState } from '../../../PageEmptyState'
import Text from '../../../Text'
import { useApplicantProfileContext } from '../RentalPortalApplicantProfile.hooks'

import {
  APPLICANT_PROFILE_UPDATES_PAGE_SIZE,
  QA_NAME_APPLICANT_PROFILE_UPDATES,
  QA_NAME_APPLICANT_PROFILE_UPDATES_RETRY,
} from './RentalPortalApplicantProfileUpdates.constants'
import { toApplicantProfileUpdates } from './RentalPortalApplicantProfileUpdates.utils'

import * as styles from './RentalPortalApplicantProfileUpdates.module.css'

import RefreshIcon from '../../../../icons/refresh.svg'
import RentalPortalIcon from '../../../../icons/rental-portal.svg'

function RentalPortalApplicantProfileUpdates() {
  const { t } = useTranslation()

  const { applicantData } = useApplicantProfileContext()

  const applicantId = applicantData?.id

  const applicantUpdatedAt = applicantData?.updated

  const {
    getThresholdItemProps,
    hasError,
    items,
    loadingInitial,
    loadingMore,
    updateListData,
  } = useInfiniteItemsListLoader({
    apiParams: { applicantId, size: APPLICANT_PROFILE_UPDATES_PAGE_SIZE },
    getData: getRentalPortalApplicantTimeline,
    getDataItems: getItemsFromIdwellApiResponse,
    loadPermission: Boolean(applicantId),
    withPagination: true,
  })

  const loadedUpdatedAtRef = useRef(applicantUpdatedAt)

  useEffect(() => {
    if (applicantUpdatedAt !== loadedUpdatedAtRef.current) {
      if (loadedUpdatedAtRef.current && applicantUpdatedAt) {
        updateListData()
      }

      loadedUpdatedAtRef.current = applicantUpdatedAt
    }
  }, [applicantUpdatedAt])

  function handleClickRetry() {
    updateListData()
  }

  return (
    <div
      {...getQaSelector({ value: QA_NAME_APPLICANT_PROFILE_UPDATES })}
      className={styles.RentalPortalApplicantProfileUpdates}
    >
      {hasError ? (
        <PageEmptyState EntityIcon={RentalPortalIcon}>
          <Text isSecondary>
            {t('RentalPortal.ApplicantProfileUpdatesLoadErrorKey')}
          </Text>
          <Button.Flat
            beforeIconProps={{ Icon: RefreshIcon }}
            isLoading={loadingInitial}
            qaName={QA_NAME_APPLICANT_PROFILE_UPDATES_RETRY}
            text={t('RentalPortal.ListingRetryBtnKey')}
            onClick={handleClickRetry}
          />
        </PageEmptyState>
      ) : (
        <EntityProfileTabUpdates
          emptyStateTextKey='RentalPortal.ApplicantProfileUpdatesEmptyKey'
          getThresholdItemProps={getThresholdItemProps}
          isLoading={loadingInitial}
          isLoadingMore={loadingMore}
          items={toApplicantProfileUpdates({ items: items ?? EMPTY_LIST, t })}
        />
      )}
    </div>
  )
}

export default RentalPortalApplicantProfileUpdates
